export const emptyPost = {
  id: null,
  name: "",
  startedAt: "",
  location: "",
  description: "",
};
